import { Component, OnInit, TemplateRef } from '@angular/core';
import { Location, JsonPipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { serviceURLService } from '../service/serviceURL';
import { SharingDataService } from '../service/sharing-data.service';
import { proposalData } from './doctors-proposal-data.model';
import { WindowRef } from '../service/WindowRef.service';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
import { ToasterService } from '../services/toaster.service';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { config } from '../config';
declare var $: any;


@Component({
  selector: 'app-doctors-professional-indemnity-quote',
  templateUrl: './doctors-professional-indemnity-quote.component.html',
  styleUrls: ['./doctors-professional-indemnity-quote.component.css'],
  providers: [ToasterService]
})
export class DoctorsProfessionalIndemnityQuoteComponent implements OnInit {
  modalRef: BsModalRef;
  quotesDetailsTable: boolean = true;
  loading: boolean;
  thankYou: boolean = false;
  error: string;
  data: any = {};
  quoteDataGenerali: object = {};
  quoteDataUnitedIndia: object = {};
  selectedLOI = "30 Lacs";
  specialization: string;
  proposalFormDPI: boolean;
  f: proposalData = new proposalData();
  activeTab: string = 'details';
  selectedFile: File;
  selectedFileName: string;
  fileArray = [];
  fileNameArray = [];
  uploading: boolean;
  private onDestroy$: Subject<void> = new Subject<void>();
  public startDate;
  policyStartDate: Date;
  policyEndDate: Date;
  quoteIdUnitedIndia: string;
  quoteIdFutureGenerali: string;
  sectionUnitedIndia: boolean = true;
  SectionFutureGenerali: boolean = true;
  insurerLogo: boolean = true;
  selectedTerritory: string = 'India';

  public qualification: any[] = [{
    qualification: '',
    year: '',
  }];
  updatedProspectIdPI: string;
  rzp1: any;
  txnId: string = '';
  paymentSuccessSection: boolean = false;
  dataUnitedIndia: {};
  dataFutureGenerali: {};
  // isMobileApp: boolean;
  //options for RazorPay
  options = {
    key: environment.dpiRazorpayKey,
    //amount: this.savedTotalPremium, //  = INR 1
    name: 'SecureNow',
    description: 'Purchase description',
    image: "https://pamstaging2.securenow.in/static/images/securenow_logo.svg",
    order_id: this.txnId,
    //  callback_url: 'https://www.google.com',
    handler: function (response) {
      this.transactionData = {
        "txnId": response.razorpay_order_id,
        "razorpaySignature": response.razorpay_signature,
        "razorpayPaymentId": response.razorpay_payment_id,
        "isMobileApp": true
      }
      if (typeof response.razorpay_payment_id == 'undefined' || response.razorpay_payment_id < 1) {
        alert("error with payment Id " + response.razorpay_payment_id);
      } else {
        $.ajax({
          url: environment.msUrl + "/profession/api/v1/payment-acknowledge-razorpay?txnId=" + response.razorpay_order_id + "&razorpaySignature=" + response.razorpay_signature + "&razorpayPaymentId=" + response.razorpay_payment_id + "&isMobileApp=" + true,
          type: "POST",
          data: this.transactionData,
          contentType: "application/json; charset=utf-8",
          success: function (data) {
            // console.log(data.message, data.success);

            location.href = '/doctor-profession-transaction';
          },
          error: function (data) {
            alert(data.message);
            location.href = '/';
          }
        })
      }

    },
    prefill: {

    },
    notes: {

    },
    theme: {
      color: "#005BAA"
    },
  };
  totalPremium: string;
  serviceTax: number;
  totalPremiumIncludedTax: number;
  totalPremiumForFutureGenerali: boolean;
  totalPremiumForUnitedIndia: boolean;
  quoteId: string;

  constructor(private _location: Location, private router: Router, private activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService, private sharingDataService: SharingDataService, private modalService: BsModalService, private winRef: WindowRef, public toasterService: ToasterService) {
    this.startDate = new Date();
    this.policyStartDate = this.startDate
    this.f.retroactiveDate = this.startDate
  }

  ngOnInit() {
    // this.sharingDataService.returnSpecialization.subscribe(url => this.specialization = url);
    this.specialization = localStorage.getItem("specialisation")
    this.getFutureGeneraliQuoteDetails();
    // setTimeout(() => {
    //   this.getUnitedIndiaQuoteDetails();
    // }, 400);

    this.updateProspect();
    // this.setPolicyEndDate();
    this.getAutopopulatedData();

  }

  changeLOI() {
    if (this.selectedLOI == "30 Lacs" || this.selectedLOI == "50 Lacs" || this.selectedLOI == "70 Lacs" || this.selectedLOI == "1 Crore") {
      this.insurerLogo = true;
      this.SectionFutureGenerali = true;
    } else {
      this.insurerLogo = false;
      this.SectionFutureGenerali = false;
    }
    localStorage.setItem("sumInsured", this.selectedLOI)
    this.getUnitedIndiaQuoteDetails();
    this.getFutureGeneraliQuoteDetails();
  }

  changeTerritory() {
    this.getUnitedIndiaQuoteDetails();
    this.getFutureGeneraliQuoteDetails();
  }

  addQual() {
    this.qualification.push({
      qualification: '',
      year: '',
    });
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  openProspectModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  getAutopopulatedData() {
    localStorage.setItem("sumInsured", this.selectedLOI)
    setTimeout(() => {
      this.f.firstName = localStorage.getItem("name").split(" ")[0];
      this.f.lastName = localStorage.getItem("name").split(" ").slice(-2).join(' ');
      this.f.mobile = localStorage.getItem("mobileNumber");
      this.f.email = localStorage.getItem("email");
      this.f.selectedSpecialization = localStorage.getItem("specialisation");
      this.f.sumInsured = localStorage.getItem("sumInsured");
    }, 500);
  }

  updateProspect() {
    this.updatedProspectIdPI = localStorage.getItem("prospectIdPI");
    if (this.updatedProspectIdPI == "") {
      this.updatedProspectIdPI = "";
    }
    //  console.log("updatedProspectIdPI2 ",this.updatedProspectIdPI);

    this.data = {
      channel: "Notify-App",
      company: "",
      email: localStorage.getItem("email"),
      location: "",
      mobile: localStorage.getItem("mobileNumber"),
      product: 83,
      prospectId: this.updatedProspectIdPI,
      leadSource: "Notify-App"
    }

    this.serviceURLService.createProspect(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.modalRef.hide();
      // this.router.navigate(['personal-accident-proposal']);
      // console.log("NOTE: ",successData.data.message);
      localStorage.setItem("prospectIdPI", successData.data.prospectId)

    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getUnitedIndiaQuoteDetails() {
    this.loading = true;
    //  console.log("in united",this.specialization);
    this.data = {
      "XLEW_4_4_3": "Individual Practice",
      "XLEW_4_8_3": 0,
      "XLEW_4_10_3": 0,
      "XLEW_5_3_4": this.selectedTerritory,
      "XLEW_5_5_4": "United India Insurance Company Ltd.",
      "XLEW_5_6_2": "Premium (Rs. excluding service tax)",
      "XLEW_5_13_2": "Loss of Documents",
      "XLEW_5_14_2": "Libel & Slander",
      "XLEW_5_15_2": "Defamation",
      "XLEW_5_16_2": "Breach of Confidential Information",
      "XLEW_5_17_2": "Pre-Litigation Cost",
      "XLEW_5_20_4": "Not covered",
      "_Ctrl_3": this.specialization,
      "_Ctrl_6": this.selectedLOI
    }
    this.serviceURLService.getDoctorPIquoteDetails(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      //  console.log("successData united India",successData);
      if (successData.XLEW_5_6_4 == 0) {
        this.sectionUnitedIndia = false;
      } else {
        this.quoteDataUnitedIndia = successData;
      }

      setTimeout(() => {
        this.saveUnitedIndiaIndemnityData(this.quoteDataUnitedIndia);
      }, 500);

    }, errorData => {
      console.log("Oops..!! there is some issue in getting united india data");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  saveUnitedIndiaIndemnityData(data) {
    var prospectIdPI = localStorage.getItem("prospectIdPI");
    var excessIndiaUnited = data.XLEW_5_9_4;

    if (localStorage.getItem("quoteIdDpi")) {
      var quoteIdDpi = localStorage.getItem("quoteIdDpi");
    }
    if (this.selectedLOI <= "2 Crore") {
      console.log(this.selectedLOI);
    }
    // console.log("prospectIdPI ",prospectIdPI)
    this.loading = true;
    this.dataUnitedIndia = {
      "buyingFor": "Individual Practice",
      "excessIndia": excessIndiaUnited,
      "insurerLogo": "United India Insurance Company Ltd.",
      "jurisdiction": this.selectedTerritory,
      "ipdCase": 0,
      "netPremium": data.XLEW_5_6_4,
      "opdCase": 0,
      "quoteId": quoteIdDpi,
      "prospectId": prospectIdPI,
      "radioActive": "Not covered",
      "territoryAndJurisdiction": this.selectedTerritory,
      "specialization": this.specialization,
      "sumAssured0": this.selectedLOI
    }
    this.serviceURLService.saveDoctorProfessionIndemnityData(this.dataUnitedIndia).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;

      // this.quoteDataGenerali = successData;
      // console.log("quoteId",successData.data);
      this.quoteIdUnitedIndia = successData.data
      localStorage.setItem("quoteIdDpi", this.quoteIdUnitedIndia)

    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getFutureGeneraliQuoteDetails() {
    this.loading = true;
    this.data = {
      "XLEW_4_4_3": "Individual Practice",
      "XLEW_4_8_3": 0,
      "XLEW_4_10_3": 0,
      "XLEW_5_3_4": this.selectedTerritory,
      "XLEW_5_5_4": "Future Generali India Insurance Company Ltd.",
      "XLEW_5_6_2": "Premium (Rs. excluding service tax)",
      "XLEW_5_13_2": "Loss of Documents",
      "XLEW_5_14_2": "Libel & Slander",
      "XLEW_5_15_2": "Defamation",
      "XLEW_5_16_2": "Breach of Confidential Information",
      "XLEW_5_17_2": "Pre-Litigation Cost",
      "XLEW_5_20_4": "Not covered",
      "_Ctrl_3": this.specialization,
      "_Ctrl_6": this.selectedLOI
    }
    this.serviceURLService.getDoctorPIquoteDetails(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      // console.log("successData Generali",successData);

      if (successData.XLEW_5_6_4 == 0) {
        this.SectionFutureGenerali = false;
      } else {
        this.quoteDataGenerali = successData;
      }
      setTimeout(() => {
        this.saveFutureGeneraliIndemnityData(this.quoteDataGenerali);
        this.getUnitedIndiaQuoteDetails();
      }, 500);

    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }



  saveFutureGeneraliIndemnityData(data) {
    var prospectIdPI = localStorage.getItem("prospectIdPI");
    var excessFutureGenerali = data.XLEW_5_9_4;

    if (localStorage.getItem("quoteIdDpi")) {
      var quoteIdDpi = localStorage.getItem("quoteIdDpi");
    }
    // console.log("prospectIdPI future",prospectIdPI)
    this.loading = true;
    this.dataFutureGenerali = {
      "buyingFor": "Individual Practice",
      "excessIndia": excessFutureGenerali,
      "insurerLogo": "Future Generali India Insurance Company Ltd.",
      "jurisdiction": this.selectedTerritory,
      "ipdCase": 0,
      "netPremium": data.XLEW_5_6_4,
      "opdCase": 0,
      "quoteId": quoteIdDpi,
      "prospectId": prospectIdPI,
      "radioActive": "Not covered",
      "territoryAndJurisdiction": this.selectedTerritory,
      "specialization": this.specialization,
      "sumAssured0": this.selectedLOI
    }
    this.serviceURLService.saveDoctorProfessionIndemnityData(this.dataFutureGenerali).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;

      // this.quoteDataGenerali = successData;
      // console.log("quoteId future",successData.data);
      this.quoteIdFutureGenerali = successData.data
      localStorage.setItem("quoteIdDpi", this.quoteIdFutureGenerali)

    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  downloadPDF(insurer) {
    if (insurer == 'futureGenerali'){
      // this.getFutureGeneraliQuoteDetails();
      this.saveFutureGeneraliIndemnityData(this.quoteDataGenerali);
      setTimeout(() => {
        this.downloadPDFGenerali();
      }, 500);
      
    } else {
      // this.getUnitedIndiaQuoteDetails();
      this.saveUnitedIndiaIndemnityData(this.quoteDataUnitedIndia);
      setTimeout(() => {
        this.downloadPDFUnited();
      }, 500);
      
    }
  }

  downloadPDFGenerali() {
    window.open(environment.msUrl + config.downloadDocPIPDF + this.quoteIdFutureGenerali);
  }

  downloadPDFUnited() {
    window.open(environment.msUrl + config.downloadDocPIPDF + this.quoteIdUnitedIndia);
  }

  sendPDF(insurer){
    if (insurer == 'futureGenerali'){
      // this.getFutureGeneraliQuoteDetails();
      this.saveFutureGeneraliIndemnityData(this.quoteDataGenerali);
    this.quoteId =  this.quoteIdFutureGenerali;
    } else {
      // this.getUnitedIndiaQuoteDetails();
      this.saveUnitedIndiaIndemnityData(this.quoteDataUnitedIndia);
      this.quoteId = this.quoteIdUnitedIndia;
    }
        this.serviceURLService.sendMailDocPIPDF(this.quoteId).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
          
        }, errorData => {
          if(errorData.error.status === 403){
            this.error = errorData.error.message;
          }
        })
  }

  calculatePremium(premium, insurer){
    if(this.selectedLOI == "30 Lacs" || this.selectedLOI == "50 Lacs" || this.selectedLOI == "70 Lacs" || this.selectedLOI == "1 Crore") {
      if(insurer == 'futureGenerali'){
        this.totalPremiumForFutureGenerali = true;
        this.totalPremiumForUnitedIndia = false;
      } else {
        this.totalPremiumForUnitedIndia = true;
        this.totalPremiumForFutureGenerali = false;
      }
      this.totalPremium = premium;
      this.totalPremiumIncludedTax = JSON.parse(premium)*1.18;
      this.serviceTax = this.totalPremiumIncludedTax - JSON.parse(this.totalPremium);
      this.thankYou = false;
    } else {
      this.thankYou = true;
    }
  }

  initiatePaymentForUnitedIndia(loi) {
    // console.log("in initiate payment united ",loi)
    // if (this.selectedLOI == "30 Lacs" || this.selectedLOI == "50 Lacs" || this.selectedLOI == "70 Lacs" || this.selectedLOI == "1 Crore"){
      this.loading = true;
      this.data = {
        insurer: "united-india-insurance",
        option: 0,
        popUpVal: "popUpVal",
        quoteId: this.quoteIdUnitedIndia,
        rmLogin: ""
      }
      this.serviceURLService.initiatePayment(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
  
        this.txnId = successData.data.transactionId;
        localStorage.setItem("secureNowTxnRefNo", successData.data.secureNowTxnRefNo)
        localStorage.setItem("LOI", loi)
        // console.log("successData txnId ",this.txnId);
        this.initPay();
        this.saveUnitedIndiaIndemnityData(this.quoteDataUnitedIndia);
      }, errorData => {
        console.log("Oops..!! Error");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    // } else {
    //   this.thankYou = true;
    //   // this.toasterService.showErrorToaster("Thank You, we will call you back in 24 hours.");
    // }
    
  }

  initiatePaymentForGenerali(loi) {
    // console.log("in initiate payment generali ",loi)
    // if (this.selectedLOI == "30 Lacs" || this.selectedLOI == "50 Lacs" || this.selectedLOI == "70 Lacs" || this.selectedLOI == "1 Crore") {
      this.loading = true;
      this.data = {
        insurer: "future-generali-india-insurance",
        option: 1,
        popUpVal: "popUpVal",
        quoteId: this.quoteIdFutureGenerali,
        rmLogin: ""
      }
      this.serviceURLService.initiatePayment(this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
        this.txnId = successData.data.transactionId;
        localStorage.setItem("secureNowTxnRefNo", successData.data.secureNowTxnRefNo)
        localStorage.setItem("LOI", loi)
        // console.log("successData txnId ",this.txnId);
        this.initPay();
        this.saveFutureGeneraliIndemnityData(this.quoteDataGenerali);
      }, errorData => {
        console.log("Oops..!! Error");
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
    // } else {
    //   this.thankYou = true;
    //   // this.toasterService.showErrorToaster("Thank You, we will call you back in 24 hours."); 
    // }
  }

  initPay() {
    // console.log("intipay txnId ",this.txnId);
    this.options.order_id = this.txnId;
    this.rzp1 = new this.winRef.nativeWindow.Razorpay(this.options);
    this.rzp1.open();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
